/**
 * Loading placeholders.
 *
 * A gradient sweep, not a pulse: a pulse reads as "broken/blinking" while a
 * sweep reads as "arriving". The animation lives in the `.skeleton` class in
 * index.css.
 *
 * Skeletons should mirror the real layout they replace — a title bar sized to
 * the real title, then bars at `h-11` matching input height — so the page does
 * not jump when data lands.
 */
export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`skeleton rounded-md ${className}`} aria-hidden="true" />;
}

export function SkeletonTableRows({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-b border-line-hairline">
          {Array.from({ length: cols }).map((_, c) => (
            // Matches Td's real padding, so rows do not resize on load.
            <td key={c} className="px-4 py-3.5">
              <Skeleton className="h-4 w-full max-w-[140px]" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export function SkeletonCard() {
  return (
    <div className="rounded-xl border border-line bg-card p-5">
      <Skeleton className="mb-3 h-4 w-24" />
      <Skeleton className="h-7 w-32" />
    </div>
  );
}
